export default {
  patrimonyShares: {
    title: 'Répartition du patrimoine',
    subtitle: 'Sur la base des éléments renseignés',
    helpMessage: 'La répartition du patrimoine dans le couple est révélateur des actions à mener pour améliorer la protection du conjoint et l\'optimisation de la transmission.',
    views: {
      patrimonyShares: {
        label: 'Répartition du patrimoine entre biens propres et communs/indivis',
        pedagogicalContent: '<p>Dans le cadre d\'un régime de communauté, chaque époux est propriétaire de ses biens propres et des biens communs considérés comme appartenant aux deux époux.</p><p>En principe, les biens acquis pendant le mariage sont considérés comme des biens communs des époux, y compris lorsqu\'ils l\'ont été au moyen des gains, salaires et revenus de leurs biens propres. Par exception, les biens acquis via transmission ou en remploi de biens propres restent des biens propres.</p>',
        chart: {
          default: 'Patrimoine total',
          own: 'Patrimoine propre',
          common: 'Patrimoine commun',
          indivis: 'Patrimoine indivis',
        },
      },
      lifeInsurance: {
        label: 'Répartition du patrimoine actif successoral | ASV',
        pedagogicalContent: '<p>Vos biens composant l\'actif successoral et les capitaux décès des contrats d\'assurance-vie subissent un traitement juridique et fiscal différent dans le cadre de la transmission.</p><p>Dans le cadre de la transmission, les capitaux décès des contrats d\'assurance-vie subissent un traitement juridique et fiscal différent des biens composant l\'actif successoral. En effet, ces capitaux décès sont versés à un ou des bénéficiaires que vous désignez et bénéficient d\'une fiscalité attractive.</p>',
        chart: {
          succession: 'Actif successoral',
          patrimony: 'Patrimoine en assurance vie du client',
        },
      },
      nonLiquid: {
        label: 'Répartition du patrimoine illiquide | liquide en cas de décès',
        pedagogicalContent: '<p>Les droits de succession sont à régler dans les 6 mois du décès. En l\'absence de liquidité, vos héritiers pourraient être amenés à vendre des biens du patrimoine familial dans la précipitation pour respecter cette échéance.</p>',
      },
    },
  },
  ongoingLoans: {
    title: 'Couverture des emprunts en cours',
    subtitle: 'Part des emprunts assurés',
    helpMessage: '',
    chart: {
      coveredLoans: 'Montant couvert',
      nonCoveredLoans: 'Montant non couvert',
    },
  },
  lifeInsurance: {
    subtitle: "Sélectionner un contrat pour voir le détail",
    title: "Vos contrats d'assurance vie",
  },
  yourCurrentSituation: {
    currentSituation: {
      subtitle: "En date du {day}",
      title: "Votre situation actuelle",
      views: {
        maritalStatus: 'Statut Marital',
        situation: 'Situation familiale',
        age: 'Âge ({fullName})',
        ddv: 'DDV en place',
        commonChildren: 'Enfant(s) commun(s)',
        userChildren: 'Enfant(s) non commun(s) {name}',
        children: 'Enfant(s)',
        matrimonialRegime: 'Régime matrimonial',
        values: {
          yes: 'Oui',
          no: 'Non',
        }
      },
    },
    pastDonationsAndBequestsCard: {
      subtitle: "Renseigner les donations et legs consentis par le passé",
      title: "Dispositions déjà prises",
      donationDateLabel: "Donations effectuées le {date}",
      legDateLabel: "Legs effectués le {date}",
      doneesLabel: "Donataires",
      receiversLabel: "Légataires",
      featuresLabel: "Caractéristiques",
      donationModeLabel: "Mode de la donation",
      donationTypeLabel: "Type de la donation",
      natureLabel: "Nature de la donation",
      attributionTypeLabel: "Type de legs",
    },
  },
}
